import Il404 from './404.png';
import Logo1 from './logo-1.png';
import Logo from './logo-new.png';

export { Logo1, Logo, Il404 };
